import { createContext } from 'react'
import { createContextualCan } from '@casl/react'
import Ability from './Ability'

export const AbilityContext = createContext(Ability({ agency_role: null }))
export const Can = createContextualCan(AbilityContext.Consumer)
